import { render, staticRenderFns } from "./WhiteButton.vue?vue&type=template&id=64cf7a48&scoped=true"
import script from "./WhiteButton.vue?vue&type=script&lang=js"
export * from "./WhiteButton.vue?vue&type=script&lang=js"
import style0 from "./WhiteButton.vue?vue&type=style&index=0&id=64cf7a48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cf7a48",
  null
  
)

export default component.exports